/* eslint-disable tailwindcss/migration-from-tailwind-2 */

import { cn } from '@ui/lib/utils';

/* eslint-disable tailwindcss/no-arbitrary-value */
interface LineProps {
  type?: 'center' | 'full' | 'indent';
  className?: string;
  verticalSpacer?: boolean;
}
export const Line = ({
  type = 'full',
  className,
  verticalSpacer,
}: LineProps) => {
  return (
    <div
      className={cn(
        className,
        {
          'mb-md': verticalSpacer,
          'pl-4': type === 'indent',
        },

        'h-px w-full border-t border-shadow',
      )}
    />
  );
};
